import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Value } from '@utils/constants';
import { axios } from '@utils/lib';
import { IListRes } from '@interfaces/apis/response-data';
import paths from '@utils/constants/paths';

export const getFacilityAsync = createAsyncThunk(
  'api/tenant',
  async (query: IFacilityQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const searchQuery: Record<string, string> = {
      page: String(query.page ?? Value.TABLE_PAGE_INIT),
    };
    if (query.tenantName) searchQuery.tenantName = query.tenantName;

    searchQuery.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<IFacility>>(
        Enums.HTTP_METHOD.GET,
        paths.FACILITY + '?' + params
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const getAccountAsync = createAsyncThunk(
  'api/user',
  async (query: IBaseQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const searchQuery: Record<string, string> = {
      page: String(query.page ?? Value.TABLE_PAGE_INIT),
      order: 'DESC',
    };

    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<IAccount>>(
        Enums.HTTP_METHOD.GET,
        paths.USER + '?' + params
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const resetPassAsync = createAsyncThunk(
  'api/force-change-password',
  async (id: string, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IAccount>(
        Enums.HTTP_METHOD.PUT,
        paths.USER_FORCE_CHANGE_PASSWORD.replace(':id', id)
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const getAccountDetailAsync = createAsyncThunk(
  'api/getAccountDetailAsync',
  async (id: string, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IAccount>(
        Enums.HTTP_METHOD.GET,
        paths.USER + '/' + id
      );

      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const accountRegisterAsync = createAsyncThunk(
  'auth/accountRegisterAsync',
  async (body: IAccountForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        paths.USER,
        body
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const accountUpdateAsync = createAsyncThunk(
  'auth/accountUpdateAsync',
  async (body: IAccount, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { id, ...dataBody } = body;
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PATCH,
        paths.USER + '/' + id,
        dataBody
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const accountDeleteAsync = createAsyncThunk(
  'auth/accountDeleteAsync',
  async (id: string, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.DELETE,
        paths.USER + '/' + id
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);
